export const GET_APPMENUS = "GET_APPMENUS"
export const GET_APPMENUS_SUCCESS = "GET_APPMENUS"
export const GET_APPMENUS_FAIL = "GET_APPMENUS"
